import { render } from "./HomeServicos.vue?vue&type=template&id=398f3696&scoped=true"
import script from "./HomeServicos.vue?vue&type=script&lang=js"
export * from "./HomeServicos.vue?vue&type=script&lang=js"

import "./HomeServicos.vue?vue&type=style&index=0&id=398f3696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398f3696"]])

export default __exports__